
angular.module('bmsApp.directives')
	.directive('dropdownFilter', function ($parse) {
		return {
			restrict: 'E',
			transclude: true,
			replace: true,
			templateUrl: 'ng/shared/directives/stack0/dropdown-filter/dropdownFilter.html',
			link: function (scope, element, attrs) {
				scope.dropdownToggled = function (open) {
					scope.$eval(attrs.toggled, { open: open });
				}
				
				scope.applyFilter = function () {
					scope.$eval(attrs.applyFilter);
					scope.$broadcast ('$locationChangeSuccess');
				}
				
				scope.resetFilter = function () {
					scope.$eval(attrs.resetFilter);
				}

				scope.pullRight = scope.$eval(attrs.pullRight);
			}

		};
	});

